<template>
    <div class="container">
        <div @click="goBack" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i> 返回
        </div>
        <el-tabs v-model="activeTab">
            <!-- 用户信息 -->
            <el-tab-pane label="用户信息" name="userInfo">
                <el-card v-loading="loading.userInfo">
                    <div v-if="userInfo" class="detail-info">
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="detail-label">用户ID</span>
                                <span class="detail-value">{{ userInfo.uid }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">账号</span>
                                <span class="detail-value">
                                    <span v-if="accountVisible">{{ userInfo.account }}</span>
                                    <el-button v-else type="text" :loading="accountLoading" @click="viewUserAccount()">
                                        <i class="el-icon-view" style="font-size: 18px; color: #409eff"></i>
                                    </el-button>
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">昵称</span>
                                <span class="detail-value">{{ userInfo.nickname }}</span>
                            </div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="detail-label">头像</span>
                                <span class="detail-value">{{ userInfo.avatar || '无' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">账号类型</span>
                                <span class="detail-value">{{ userInfo.account_type === 0 ? '邮箱' : '未知' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">终端</span>
                                <span class="detail-value">{{ appName[userInfo.schema] || userInfo.schema }}</span>
                            </div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="detail-label">涂鸦区域</span>
                                <span class="detail-value">{{ userInfo.tuya_region }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">涂鸦UID</span>
                                <span class="detail-value">{{ userInfo.tuya_uid }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">注册国家</span>
                                <span class="detail-value">{{ userInfo.register_country }}</span>
                            </div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="detail-label">注册时间</span>
                                <span class="detail-value">{{ formatTimestamp(userInfo.register_time) }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">更新时间</span>
                                <span class="detail-value">{{ formatTimestamp(userInfo.update_time) }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">删除时间</span>
                                <span class="detail-value">{{ userInfo.delete_time ?
                                    formatTimestamp(userInfo.delete_time) : '未删除' }}</span>
                            </div>
                        </div>
                    </div>
                    <el-empty v-else description="暂无用户信息" />
                </el-card>
            </el-tab-pane>

            <!-- 登录APP列表 -->
            <el-tab-pane label="登录APP列表" name="loginApp">
                <el-card v-loading="loading.loginApp">
                    <template #header>
                        <div class="card-header"><span>登录APP列表</span></div>
                    </template>
                    <el-table v-if="loginAppList.length > 0" border :data="loginAppList" size="small"
                        show-overflow-tooltip :header-cell-style="{ 'white-space': 'nowrap' }">
                        <el-table-column label="设备类型" width="70" align="center">
                            <template v-slot="{ row }">{{ row.device_type == 1 ? '安卓' : row.device_type == 2 ? 'IOS' :
                                '未知' }}</template>
                        </el-table-column>
                        <el-table-column label="设备时区" prop="device_zone" width="80" align="center"></el-table-column>
                        <el-table-column label="APP包名" prop="app_package_name" min-width="100"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="设备型号" prop="device_model" width="100"></el-table-column>
                        <el-table-column label="设备唯一标志" prop="device_code" width="140"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column label="设备品牌" prop="device_brand" width="80"></el-table-column>
                        <el-table-column label="系统版本" prop="device_system_version" width="80"></el-table-column>
                        <el-table-column label="终端" width="80">
                            <template v-slot="{ row }">{{ appName[row.schema] || row.schema }}</template>
                        </el-table-column>
                        <el-table-column label="APP版本" prop="app_version" width="80"></el-table-column>
                        <el-table-column label="屏幕尺寸" prop="phone_screen" width="90"></el-table-column>
                        <el-table-column label="设备语言" prop="device_language" width="70"></el-table-column>
                        <el-table-column label="国家码" prop="country_code" width="60"></el-table-column>
                        <el-table-column label="最近登陆时间(UTC)" width="160" align="center">
                            <template v-slot="{ row }">{{ formatTimestamp(row.login_time) }}</template>
                        </el-table-column>
                        <el-table-column label="access_token过期时间(UTC)" min-width="180" align="center">
                            <template v-slot="{ row }">{{ formatTimestamp(row.expires_in) }}</template>
                        </el-table-column>
                        <el-table-column label="推送token" width="80" align="center">
                            <template v-slot="{ row }">
                                <el-popover v-if="row.push_token" placement="top" width="400" trigger="click">
                                    <template #reference>
                                        <el-button type="text">
                                            <i class="el-icon-view" style="font-size: 16px; color: #409EFF"></i>
                                        </el-button>
                                    </template>
                                    <div style="word-break: break-all">{{ row.push_token }}</div>
                                </el-popover>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="推送类型" width="70" align="center">
                            <template v-slot="{ row }">{{ pushTypeMap[row.push_type] || '未知' }}</template>
                        </el-table-column>
                    </el-table>
                    <el-empty v-else description="暂无登录APP记录" />
                </el-card>
            </el-tab-pane>

            <!-- 信任设备列表 -->
            <el-tab-pane label="信任设备列表" name="trustDevice">
                <el-card v-loading="loading.trustDevice">
                    <template #header>
                        <div class="card-header"><span>信任设备列表</span></div>
                    </template>
                    <el-table v-if="trustDeviceList.length > 0" border :data="trustDeviceList" size="small">
                        <el-table-column label="用户UID" prop="uid"></el-table-column>
                        <el-table-column label="设备代码" prop="device_code" min-width="200"></el-table-column>
                        <el-table-column label="设备名称" prop="device_name"></el-table-column>
                        <el-table-column label="手机品牌" prop="phone_brand"></el-table-column>
                        <el-table-column label="手机型号" prop="phone_model"></el-table-column>
                        <el-table-column label="添加时间">
                            <template v-slot="{ row }">{{ formatTimestamp(row.create_time) }}</template>
                        </el-table-column>
                    </el-table>
                    <el-empty v-else description="暂无信任设备记录" />
                </el-card>
            </el-tab-pane>

            <!-- 设备列表 -->
            <el-tab-pane label="设备列表" name="deviceList">
                <el-card v-loading="loading.deviceList">
                    <template #header>
                        <div class="card-header"><span>设备列表</span></div>
                    </template>
                    <el-table v-if="deviceList.length > 0" border :data="deviceList" size="small">
                        <el-table-column label="设备UUID" width="270">
                            <template v-slot="{ row }">
                                <span style="color: #409eff; cursor: pointer" @click="viewDeviceDetail(row)">{{ row.uuid
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="设备名称" prop="name" width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column label="设备型号" prop="model_code" width="140"></el-table-column>
                        <el-table-column label="绑定关系">
                            <template v-slot="{ row }">{{ { 1: '主人', 2: '分享' }[row.bind_type] || '未知' }}</template>
                        </el-table-column>
                        <el-table-column label="设备类型">
                            <template v-slot="{ row }">{{ { 1: '一级设备', 2: '二级设备' }[row.device_type] || '未知'
                            }}</template>
                        </el-table-column>
                        <el-table-column label="固件类型">
                            <template v-slot="{ row }">{{ { 0: 'P2P', 1: 'RTC' }[row.online_type] || '未知' }}</template>
                        </el-table-column>
                        <el-table-column label="休眠状态">
                            <template v-slot="{ row }">
                                <el-tag :type="row.open_status === 1 ? 'success' : 'danger'" size="small">{{
                                    row.open_status === 1 ? '开机' : '休眠' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="P2P在线状态" width="100">
                            <template v-slot="{ row }">
                                <el-tag :type="row.p2p_online === 1 ? 'success' : 'danger'" size="small">{{
                                    row.p2p_online === 1 ? '在线' : '离线' }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="绑定状态">
                            <template v-slot="{ row }">
                                <el-tag :type="row.status === 1 ? 'success' : row.status === 2 ? 'warning' : 'danger'"
                                    size="small">
                                    {{ row.status === 1 ? '绑定' : row.status === 2 ? '解绑' : '未知' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="免费试用记录" width="100">
                            <template v-slot="{ row }">{{ { 0: '未使用', 1: '已使用' }[row.trial_status] || '未知' }}</template>
                        </el-table-column>
                        <el-table-column label="最近一次绑定时间" width="160">
                            <template v-slot="{ row }">{{ formatTimestamp(row.bind_time) }}</template>
                        </el-table-column>
                        <el-table-column label="首次绑定时间" width="160">
                            <template v-slot="{ row }">{{ formatTimestamp(row.first_time) }}</template>
                        </el-table-column>
                        <el-table-column label="解绑时间" width="160">
                            <template v-slot="{ row }">{{ row.delete_time ? formatTimestamp(row.delete_time) : '未解绑'
                            }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="180" fixed="right">
                            <template v-slot="{ row }">
                                <el-button size="mini" type="primary" @click="viewCloudStorage(row)">云存储</el-button>
                                <el-button v-if="(row.online_type === 1 || isHuntingDevice(row)) && row.bind_type == 1"
                                    size="mini" type="success" @click="viewDeviceShadow(row)">设备影子</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-empty v-else description="暂无设备记录" />
                </el-card>
            </el-tab-pane>
        </el-tabs>

        <!-- 云存储弹窗 -->
        <el-dialog v-model="cloudStorageDialog.visible"
            :title="'云存储信息 - ' + (cloudStorageDialog.deviceInfo.uuid || '设备')" width="85%">
            <div v-loading="cloudStorageDialog.loading">
                <el-empty v-if="!cloudStorageDialog.loading && cloudStorageDialog.data.length === 0"
                    description="暂无云存储数据" />
                <el-table v-else :data="cloudStorageDialog.data" stripe border size="small" max-height="500">
                    <el-table-column prop="order_id" label="订单ID" width="260" show-overflow-tooltip align="center" />
                    <el-table-column prop="uuid" label="设备UUID" width="260" show-overflow-tooltip align="center" />
                    <el-table-column prop="uid" label="用户UID" width="120" align="center" />
                    <el-table-column label="开始时间" width="150" align="center">
                        <template v-slot="{ row }">{{ formatTimestamp(row.start_time) }}</template>
                    </el-table-column>
                    <el-table-column label="过期时间" width="150" align="center">
                        <template v-slot="{ row }">{{ formatTimestamp(row.end_time) }}</template>
                    </el-table-column>
                    <el-table-column prop="file_time" label="存储时长(天)" width="110" align="center" />
                    <el-table-column label="订阅状态" width="90" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
                                {{ row.status === 0 ? '未订阅' : row.status === 1 ? '已订阅' : '未知' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="云类型" width="80" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="row.is_event === 1 ? 'success' : 'info'" size="small">
                                {{ row.is_event === 0 ? '全时云' : row.is_event === 1 ? '事件云' : '未知' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="终端" width="80" align="center">
                        <template v-slot="{ row }">{{ appName[row.schema] || row.schema }}</template>
                    </el-table-column>
                    <el-table-column label="删除状态" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="row.is_delete === 0 ? 'success' : 'danger'" size="small">{{ row.is_delete ===
                                0 ? '未删除' : '已删除' }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="过期状态" align="center">
                        <template v-slot="{ row }">
                            <el-tag :type="!row.is_expired ? 'success' : 'warning'" size="small">{{ row.is_expired ?
                                '已过期' : '未过期' }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="套餐等级" align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small">{{ getLevelTextDynamic(row.level) }}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <template #footer><el-button @click="cloudStorageDialog.visible = false">关闭</el-button></template>
        </el-dialog>

        <!-- 设备影子弹窗 -->
        <DeviceShadowDialog v-model="deviceShadowVisible" :shadow-data="deviceShadowDialog.data"
            :loading="deviceShadowDialog.loading" :device-info="deviceShadowDialog.deviceInfo"
            @close="closeDeviceShadowDialog" destroy-on-close />
    </div>
</template>

<script>
import { ref, reactive, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import queryApi from '../../../axios/queryApi'
import DeviceShadowDialog from '../../../components/device/DeviceShadowDialog.vue'

dayjs.extend(utc)

const pushTypeMap = { 1: '极光', 2: 'FCM', 3: 'APNS', 4: '个推', 5: '友盟' }

function formatTimestamp(timestamp) {
    if (!timestamp || timestamp === 0) return '无'
    return dayjs.unix(timestamp).utc().format('YYYY-MM-DD HH:mm:ss')
}

function getLevelText(level) {
    return '等级' + level
}

// 目前约定：型号以 WT10_ 开头的设备为猎机（打猎相机）
function isHuntingDevice(target) {
    if (!target) return false
    const model = typeof target === 'object' ? (target.model_code || target.model) : target
    if (typeof model !== 'string') return false
    return model.toUpperCase().startsWith('WT10_')
}

export default {
    name: 'QueryUserDetail',
    components: { DeviceShadowDialog },
    setup() {
        const { proxy } = getCurrentInstance()
        const route = useRoute()
        const router = useRouter()

        // 解析路由参数: /iot/query/userdetail/:id  =>  uid&region
        const params = route.params.id || ''
        const parts = params.split('&')
        const uid = parts[0] || ''
        const region = parts[1] || ''

        const activeTab = ref('userInfo')
        const userInfo = ref(null)
        const loginAppList = ref([])
        const trustDeviceList = ref([])
        const deviceList = ref([])
        const appName = reactive({})
        const accountVisible = ref(false)
        const accountLoading = ref(false)
        const loading = reactive({ userInfo: false, loginApp: false, trustDevice: false, deviceList: false })
        const levelMap = reactive({})

        const cloudStorageDialog = reactive({ visible: false, loading: false, data: [], deviceInfo: {} })
        const deviceShadowDialog = reactive({ loading: false, data: null, deviceInfo: {} })
        const deviceShadowVisible = ref(false)
        const tslAttribute = reactive({})

        function goBack() { router.go(-1) }

        function fetchUserDetail() {
            loading.userInfo = true
            queryApi.QueryUserDetail({ uid, region }).then(res => {
                if (res.data.code == 200 && res.data.data?.user) {
                    userInfo.value = res.data.data.user
                    accountVisible.value = false
                }
            }).catch(err => {
                console.error('获取用户详情失败:', err)
            }).finally(() => {
                loading.userInfo = false
            })
        }

        function fetchLoginAppList() {
            loading.loginApp = true
            queryApi.QueryUserLoginList({ uid, region }).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    loginAppList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取登录APP列表失败:', err)
            }).finally(() => {
                loading.loginApp = false
            })
        }

        function fetchTrustDeviceList() {
            loading.trustDevice = true
            queryApi.QueryUserTrustDevList({ uid, region }).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    trustDeviceList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取信任设备列表失败:', err)
            }).finally(() => {
                loading.trustDevice = false
            })
        }

        function fetchDeviceList() {
            loading.deviceList = true
            queryApi.QueryUserDeviceList({ uid, region }).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    deviceList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取设备列表失败:', err)
            }).finally(() => {
                loading.deviceList = false
            })
        }

        function viewUserAccount() {
            if (!uid || !region) {
                proxy.$message.error('缺少必要参数')
                return
            }
            accountLoading.value = true
            queryApi.QueryUserAccount({ uid, region }).then(res => {
                if (res.data.code == 200 && res.data.data?.account) {
                    if (userInfo.value) {
                        userInfo.value.account = res.data.data.account
                        accountVisible.value = true
                    }
                } else {
                    proxy.$message.error('获取用户账号失败')
                }
            }).catch(() => {
                proxy.$message.error('获取用户账号失败')
            }).finally(() => {
                accountLoading.value = false
            })
        }

        function viewDeviceDetail(row) {
            if (!uid || !region || !row.uuid) {
                proxy.$message.error('缺少必要参数')
                return
            }
            router.push({ path: '/iot/query/device', query: { uid, region, uuid: row.uuid } })
        }

        function viewCloudStorage(row) {
            if (!uid || !region || !row.uuid) {
                proxy.$message.error('缺少必要参数')
                return
            }
            cloudStorageDialog.loading = true
            queryApi.QueryUserDeviceCloudInfo({ uid, uuid: row.uuid, region }).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    if (Array.isArray(res.data.data) && res.data.data.length === 0) {
                        proxy.$message.info('暂无云存储数据')
                        return
                    }
                    cloudStorageDialog.deviceInfo = { uuid: row.uuid, name: row.name }
                    cloudStorageDialog.data = res.data.data
                    cloudStorageDialog.visible = true
                } else {
                    proxy.$message.error(res.data.msg || '获取云存储信息失败')
                }
            }).catch(() => {
                proxy.$message.error('获取云存储信息失败')
            }).finally(() => {
                cloudStorageDialog.loading = false
            })
        }

        function viewDeviceShadow(row) {
            if (!uid || !region || !row.uuid) {
                proxy.$message.error('缺少必要参数')
                return
            }
            deviceShadowDialog.loading = true
            deviceShadowVisible.value = true
            deviceShadowDialog.deviceInfo = { uuid: row.uuid, name: row.name }
            deviceShadowDialog.data = null
            queryApi.QueryUserDeviceShadow({ uid, uuid: row.uuid, region }).then(res => {
                if (res.data.code == 200 && res.data.data) {
                    // 包装成 DeviceShadowDialog 组件期望的格式
                    deviceShadowDialog.data = {
                        shadow: res.data.data,
                        tsl_attribute: { ...tslAttribute }
                    }
                } else {
                    proxy.$message.error(res.data.msg || '获取设备影子信息失败')
                }
            }).catch(() => {
                proxy.$message.error('获取设备影子信息失败')
            }).finally(() => {
                deviceShadowDialog.loading = false
            })
        }

        function closeDeviceShadowDialog() {
            deviceShadowVisible.value = false
            deviceShadowDialog.data = null
        }

        function getAppList() {
            queryApi.QueryAppList({ page: 1, limit: 100 }).then(res => {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(item => {
                        appName[item.code] = item.name
                    })
                }
            })
        }

        function getTslAttributeList() {
            queryApi.QueryTslAttributeList({ page: 1, rows: 500 }).then(res => {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(item => {
                        tslAttribute[item.identifier] = item
                    })
                }
            })
        }

        function fetchPackageLevelList() {
            queryApi.QueryPackageLevelList({}).then(res => {
                if (res.data.code == 200) {
                    res.data.data.data.forEach(item => {
                        levelMap[item.set_meal_level] = item.level_name
                    })
                }
            })
        }

        function getLevelTextDynamic(level) {
            return levelMap[level] || ('等级' + level)
        }

        // 初始化
        getAppList()
        getTslAttributeList()
        fetchPackageLevelList()
        if (uid && region) {
            fetchUserDetail()
            fetchLoginAppList()
            fetchTrustDeviceList()
            fetchDeviceList()
        }

        return {
            activeTab, uid, region, userInfo, loginAppList, trustDeviceList, deviceList,
            appName, accountVisible, accountLoading, pushTypeMap, loading,
            cloudStorageDialog, deviceShadowDialog, deviceShadowVisible,
            formatTimestamp, goBack, getLevelTextDynamic, isHuntingDevice,
            viewUserAccount, viewDeviceDetail, viewCloudStorage, viewDeviceShadow, closeDeviceShadowDialog
        }
    }
}
</script>

<style scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
}

::v-deep(.el-card__body) {
    padding: 12px 12px 16px;
}

.detail-info {
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.detail-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
}

.detail-row:last-child {
    border-bottom: none;
}

.detail-item {
    flex: 1;
    display: flex;
    min-height: 40px;
    line-height: 40px;
}

.detail-label {
    width: 140px;
    padding: 0 12px;
    background: #fafafa;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    border-right: 1px solid #ebeef5;
    flex-shrink: 0;
}

.detail-value {
    flex: 1;
    padding: 0 12px;
    font-size: 14px;
    color: #303133;
    word-break: break-all;
}

.detail-item+.detail-item {
    border-left: 1px solid #ebeef5;
}
</style>
